import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import Navbar from "../../components/Navbar";
import BubbleExperienceModal from "../../components/bubbles/BubbleExperienceModal";
import Factorymodal from "../../components/Factorymodal";
import Megafactory from "../../pages/composable/Megafactory";
import ExperienceCard from "./components/Cards";
import { mockAssets } from "./components/CardsData";
import { useApp } from "hooks/useApp";
import { useSegment } from "hooks/useSegment";
import { useAuth } from "hooks/useAuth";
import { useDocs } from "hooks/useDocs";
import { emitToast } from "common/toastEmitter";

export default function Experience() {
  const navigate = useNavigate();
  const [experiences, setExperiences] = useState(mockAssets);
  const [openModal, setOpenModal] = useState(false);

  const {
    vtecAssets,
    activeFactory,
    activeMegaFactory,
    setActiveFactory,
    setActiveMegaFactory,
    setSelectedAsset,
  } = useApp();

  const { user } = useAuth();
  const { extractDomain } = useDocs();
  const { trackExperienceEvent } = useSegment();

  const userDomain = extractDomain(user?.email);

  const handleCardClick = useCallback(
    async (asset) => {
      if (!asset) return;

      switch (asset.Type) {
        case "factory":
          setActiveFactory(asset);
          break;

        case "megafactory":
          setActiveMegaFactory(asset);
          break;

        default:
          await trackExperienceEvent(`experience_${asset.Title}`, asset);

          if (asset.modal) {
            setOpenModal(true);
          } else if (asset.redirectTo) {
            const isNdaExperience = asset.redirectTo
              .toLowerCase()
              .endsWith("nda");

            if (isNdaExperience && userDomain !== "tulip.co") {
              emitToast(
                "You are not allowed to access this experience.",
                "error"
              );
              return;
            }

            navigate(asset.redirectTo);
          }
          break;
      }
    },
    [navigate, setActiveFactory, setActiveMegaFactory, trackExperienceEvent, userDomain]
  );

  useEffect(() => {
    if (!vtecAssets || !Array.isArray(vtecAssets)) return;

    const unifiedAsset = vtecAssets.find(
      (item) => item.Title === "Unified Name Space"
    );

    if (unifiedAsset) {
      setSelectedAsset(unifiedAsset);
      setExperiences((prev) => {
        const alreadyExists = prev.some(
          (asset) => asset.Title === unifiedAsset.Title
        );
        return alreadyExists ? prev : [...prev, unifiedAsset];
      });
    }
  }, [vtecAssets, setSelectedAsset]);

  // FILTER NDA CARDS — ONLY SHOW TO tulip.co USERS
  const filteredExperiences = experiences.filter((asset) => {
    const isNdaExperience = asset.redirectTo
      ?.toLowerCase()
      .endsWith("nda");

    if (isNdaExperience && userDomain !== "tulip.co") {
      return false;
    }

    return true;
  });

  return (
    <Box className="flex flex-col items-center min-h-screen">
      <Navbar />
      <Box className="w-full px-4 py-10">
        <Box className="flex flex-wrap gap-16 justify-center">
          {filteredExperiences.map((asset) => (
            <ExperienceCard
              key={asset.id}
              asset={asset}
              onClick={() => handleCardClick(asset)}
            />
          ))}
        </Box>
      </Box>

      {activeFactory && <Factorymodal />}
      {activeMegaFactory && <Megafactory />}
      <BubbleExperienceModal
        open={openModal}
        onClose={() => setOpenModal(false)}
      />
    </Box>
  );
}
